import React from 'react';
import PropTypes from 'prop-types';

import AccessibleIcon from '../common/AccessibleIcon';
const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');


const propTypes = {};
const defaultProps = {};

function SignedOutPromoPanel(props) {
    return (
        <SignedOutPromoBase>
            <div className="signedOutDual__promoTagline">
                {Strings['en'].signed_out.sign_in_new.promo.TAGLINE}
            </div>
            <div className="signedOutDual__promoSlugs">
                <ul>
                    <li>{Strings['en'].signed_out.sign_in_new.promo.SLUG_1}</li>
                    <li>{Strings['en'].signed_out.sign_in_new.promo.SLUG_2}</li>
                    <li>{Strings['en'].signed_out.sign_in_new.promo.SLUG_3}</li>
                </ul>
            </div>
        </SignedOutPromoBase>
    );
}

SignedOutPromoPanel.propTypes = propTypes;
SignedOutPromoPanel.defaultProps = defaultProps;

export default SignedOutPromoPanel;

export function SignedOutVerifyPanel(props) {
    return (
        <SignedOutPromoBase variant="thin">
            <div className="signedOutDual__promoTagline">
                {Strings['en'].signed_out.register_new.promo.TAGLINE}
            </div>
            <div className="signedOutDual__promoTagSub">
                {Strings['en'].signed_out.register_new.promo.TAGLINE_SUB}
            </div>
        </SignedOutPromoBase>
    );
}

export function SignedOutVerifyOrgPanel(props) {
    return (
        <SignedOutPromoBase variant="thin">
            <div className="signedOutDual__promoTagline">
                {Strings['en'].signed_out.register_new.promo.TAGLINE_ORG}
            </div>
            <div className="signedOutDual__promoTagSub">
                {Strings['en'].signed_out.register_new.promo.TAGLINE_SUB_ORG}
            </div>
        </SignedOutPromoBase>
    );
}

function SignedOutPromoBase(props) {
    let classSuffix = '';
    if (props.variant === 'thin') {
        classSuffix = '--thin';
    }

    return (
        <div className={`signedOutDual__promo${classSuffix}`}>
            <div className="signedOutDual__promoLogo">
                <img
                    className="signedOutDual__promoLogo--logo"
                    src={`${GlobalConfig.StaticUrl}/img/logo-top.svg`}
                    alt=""
                    role="presentation"
                />
                <h1 className="signedOutDual__promoLogo--header">{Strings['en'].signed_out.sign_in_new.promo.PRODUCT}</h1>
            </div>
            {props.children}
            <div className="signedOutDual__promoTrailer">
                {Strings['en'].signed_out.sign_in_new.promo.TRAILER}
            </div>
            <hr
                className="signedOutDual__promoFooterSep"
                role="presentation"
            />
            <div className="signedOutDual__promoFooter">
                <div className="signedOutDual__promoFooter--web">
                    <a href="https://www.muzzylane.com" target="_blank">
                        www.muzzylane.com
                    </a>
                    <AccessibleIcon className="fas fa-external-link-alt" label={Strings['en'].common.OPEN_NEW_TAB} />
                </div>
                <div className="signedOutDual__promoFooter--social">
                    <a href="https://www.linkedin.com/company/muzzy-lane-software" target="_blank">
                        <img
                            src={`${GlobalConfig.StaticUrl}/img/social/social-linkedin.svg`}
                            alt={Strings['en'].signed_out.sign_in_new.promo.social.LINKEDIN}
                        />
                    </a>
                    <a href="https://www.youtube.com/@muzzylaneauthor7099" target="_blank">
                        <img
                            src={`${GlobalConfig.StaticUrl}/img/social/social-youtube.svg`}
                            alt={Strings['en'].signed_out.sign_in_new.promo.social.YOUTUBE}
                        />
                    </a>
                    <a href="https://www.facebook.com/muzzylane" target="_blank">
                        <img
                            src={`${GlobalConfig.StaticUrl}/img/social/social-facebook.svg`}
                            alt={Strings['en'].signed_out.sign_in_new.promo.social.FACEBOOK}
                        />
                    </a>
                    <a href="https://x.com/MuzzyLane" target="_blank">
                        <img
                            src={`${GlobalConfig.StaticUrl}/img/social/social-x.svg`}
                            alt={Strings['en'].signed_out.sign_in_new.promo.social.X}
                        />
                    </a>
                </div>
            </div>
        </div>
    );
}

SignedOutPromoBase.propTypes = {
    variant: PropTypes.oneOf(['default', 'thin']),
    children: PropTypes.node,
};
SignedOutPromoBase.defaultProps = {
    variant: 'default',
    children: (<span/>),
};